module.exports = __webpack_public_path__ + "img/icon_my_male.5c201060.png";